import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import tradeDataStore from "@/store/tradeDataStore";
import { getFillFromStore } from "../../fillStateHelpers";
import {
  determineFilledAtDisplayValue,
  determinePendingText,
} from "./filledAtFormatter";
import { timeToActionColour } from "../../statusCellStylingHelper";

/**
 * FilledAtCellRenderer
 *
 * Displays the fill status or formatted timestamp in the Order Fills table.
 * - For pending fills (New, Updated, Cancel): Shows the fillType status
 * - For unchanged fills: Shows the filledAt timestamp formatted as "DD-Mon-YYYY HH:MM:SS"
 *
 * This allows us to preserve the original timestamp while showing
 * user-friendly status text when the fill has pending changes.
 *
 * Works in conjunction with filledAtValueFormatter for copy/paste support.
 */
const FilledAtCellRenderer = (params: any) => {
  // Subscribe to tradeData for reactive updates (hooks must run before any early return)
  const tradeData = tradeDataStore((state) => state.tradeData);

  if (!params.data) {
    return null;
  }

  const { fullTradeData } = returnAllTradeDetailsFromGenericParams(params);
  const esid = fullTradeData?.esid;
  const blockId = params.data?.blockId;
  const fillId = params.data?.fillId;
  const extFillId = params.data?.fillData?.extFillId;

  // Get the fill from the store
  // extFillId fallback: when fillId is stale after backend assigns new fillId
  const fill =
    esid && fillId !== undefined && blockId !== undefined
      ? getFillFromStore(tradeData, esid, blockId, fillId, extFillId)
      : null;

  // Use shared formatting logic
  const displayValue = determineFilledAtDisplayValue(fill, params.value);

  const pendingStyleColour = determinePendingText(fill);

  return (
    <div
      data-testid="FilledAtCellContainer"
      id="FilledAtCellContainer"
      className="flex h-full items-center justify-center"
      style={pendingStyleColour ? { color: timeToActionColour } : undefined}
    >
      {displayValue}
    </div>
  );
};

export default FilledAtCellRenderer;
